/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

export const patterns = {
  no_quotes_tilde: /^[^'\\\"~,]*$/, // This field contains an invalid value. Invalid values are ", ~ and ' 
  no_quotes_tilde_star: /^[^'"~*]*$/, // This field contains an invalid value. Invalid values are ", ', ~ and *
  no_quotes_tilde_anglebrackets: /^[^'"~<>]*$/, // This field contains an invalid value. Invalid values are >, <, ", ~ and '
  no_tilde: /^[^~]*$/,
  no_angle_brackets_hash: /^[^<>#]*$/, // This field contains an invalid value. Invalid values are <, > and #
  no_angle_brackets: /^[^<>]*$/, // This field contains an invalid value. Invalid values are < and >
  alphanumeric_hyph_under: /^[a-zA-Z0-9-_]*$/, // Valid values are a-z, A-Z, 0-9, hyphens and underscores
  alphanumeric_hyph_under_amper: /^[a-zA-Z0-9\-_\&amp;]*$/, // Valid values are a-z, A-Z, 0-9, hyphens, underscores and ampersands
  alphanumeric_hyph_under_spaces: /^[a-zA-Z0-9\s\-_\&amp;]*$/, // Valid values are a-z, A-Z, 0-9, spaces, hyphens, underscores and ampersands
  alphanumeric_hyph_under_spaces1: /^[a-zA-Z0-9\-_\&amp;]+(\s*[a-zA-Z0-9\-_\&amp;]+)*$/, // Valid values are a-z, A-Z, 0-9, spaces, hyphens, underscores and ampersands; spaces only allowed between words
  phone: /^[0-9\s]*$/, // Valid characters are 0-9 and spaces.
  phone1: /^[0-9]+(\s*[0-9]+)*$|^$/, // Valid characters are 0-9 and spaces; spaces only allowed between numbers
  hour: /^[0-9]+/,
  hour24: /^[01][0-9]|2[0-3]$/, // Valid values are 00-23
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  // password:
  //   /^(?=.*[A-Z])(?=.*\d)(?=.*[!#$()*,\./:;=?@\[\]\^_`\{\|\}~&])[A-Za-z\d!#$()*,\./:;=?@\[\]\^_`\{\|\}~&]{1,}$/, //The password must include at least one number, an upper-case letter and a lower-case letter. The supported special characters are:!#$()*,./:;=?@[]^_`{|}~
  new_password:
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!#$()*+,-.\/:;=?@\[\\\]^_`{|}~]{8,30}$|^$/, //Passwords must contain between eight and thirty characters, include at least one number, an upper-case letter and a lower-case letter. The supported special characters are: !#$()*+,-./:;=?@[\]^_`{|}~,
  max_length_15: /^.{1,15}$/,
  publish_date_format: /^(0[1-9]|1[0-2])(\/)(0[1-9]|[1-2][0-9]|3[01])(\/)\d{2}$/,
  no_comma: /^[^,]+$/ // Disallows ',' 
};
